export default __webpack_public_path__ + "static/media/zebra.be52201f.png";